import type React from 'react'
import { useNavigate } from 'react-router-dom'
import type { ICellRendererParams } from 'ag-grid-community'
import { Texto } from '@gravitate-js/excalibrr'
import type { OldestInvoiceData } from '../types/supplier'
import { generateNavigationUrlForMatch } from '../utils/navigationUtils'
import type { RecMatchRow } from '../../../../../../types/api/v1'
import { handleNavigation } from '../../../utils/navigationHelpers'

interface InvoiceNumberClickableCellRendererProps extends ICellRendererParams {
  data: OldestInvoiceData
  context?: {
    matches?: RecMatchRow[]
  }
}

function InvoiceNumberClickableCellRenderer({ data, context }: InvoiceNumberClickableCellRendererProps) {
  const navigate = useNavigate()
  const matches = context?.matches || []

  function handleClick(event: React.MouseEvent) {
    // Find the match data for this invoice using matchId
    const matchData = matches.find((match) => match.id === data.matchId)
    if (matchData) {
      const navigationResult = generateNavigationUrlForMatch(matchData, data.invoiceNumber)
      handleNavigation(navigationResult.url, navigate, event)
    } else {
      // Fallback to general Match View if match data not found
      handleNavigation('/supplier_rec/match_view', navigate, event)
    }
  }

  return (
    <span
      style={{
        color: 'var(--theme-color-2)',
        cursor: 'pointer',
        textDecoration: 'underline',
      }}
      onClick={handleClick}
    >
      {data.invoiceNumber}
    </span>
  )
}

export { InvoiceNumberClickableCellRenderer }
